import Imgix from 'react-imgix';
import Quantity from './quantity';
import ProductPriceFormat from '../../../../../products/product-price/product-price-format';
import React from 'react';
import { ICartItem } from '../../../interfaces';
import CartItemTitle from './cart-item-title';
import CartItemNotification from './cart-item-notification';
import CartItemPromos from './cart-item-promos';
import RemoveCartItemBtn from './remove-cart-item-btn';
import EnableDisableCheckbox from './enable-disable-cb';
import CartComment from './cart-comment';

interface IStep1CartItemDesktop {
    cartItem: ICartItem,
    isFirstItem: boolean,
    isLastItem: boolean,
}

const Step1CartItemDesktop = (props: IStep1CartItemDesktop) => {

    const cartItem = props.cartItem;
    const itemPriceData = cartItem.priceData;

    return (
        <>
            {
                /* top spacing */
                props.isFirstItem &&
                <div
                    className="col-span-full mt-6"
                    style={{
                        height: '1px'
                    }}
                />
            }

            <div className="mx-4">
                <EnableDisableCheckbox cartItem={ cartItem } />
            </div>

            <div className="bg-gray-150 flex items-center justify-center mx-6 p-3">
                <Imgix
                    className="lazyload"
                    src={ cartItem.skuThumb }
                    width={ 90 }
                    attributeConfig={{
                        src: 'data-src',
                        srcSet: 'data-srcset',
                        sizes: 'data-sizes',
                    }}
                    htmlAttributes={{
                        alt: `Image for ${ cartItem.skuName }`
                    }}
                />
            </div>

            <div className="text-gray-500">
                <CartItemTitle cartItem={ cartItem } classes="text-xl text-gray-700 font-bold mb-2" />

                { cartItem.cartNotification && <CartItemNotification cartItem={ cartItem } classes="text-tiny" /> }
                { cartItem.cartComment && <CartComment comment={ cartItem.cartComment } classes="text-tiny" /> }

                <div className="flex items-center mb-2">
                    {
                        itemPriceData.showMSRPPrice &&
                        <div className="mr-10" data-qa="cart-step1-product-full-price">
                            <s>
                                <ProductPriceFormat price={ cartItem.skU_MSRP } />
                            </s>
                        </div>
                    }

                    { itemPriceData.discount > 0 && <div><ProductPriceFormat price={ itemPriceData.price } /></div> }
                </div>

                <CartItemPromos cartItem={ cartItem } />

                <div className="flex items-center">
                    { cartItem.isSaveForLater && <button type="button" className="mr-10">Save for Later</button> }
                    <RemoveCartItemBtn cartItem={ cartItem } />
                </div>
            </div>

            <Quantity cartItem={ cartItem } />

            <div className="text-right mx-6">
                {
                    itemPriceData.discount > 0 &&
                    <div className="font-bold text-green" data-qa="cart-step1-product-discount">-<ProductPriceFormat price={ itemPriceData.discount }/></div>
                }

                <div className="font-bold text-gray-700 text-lg" data-qa="cart-step1-product-discount-price"><ProductPriceFormat price={ itemPriceData.priceAfterDiscount } /></div>
            </div>

            <div
                className={ !props.isLastItem ? 'border-b col-span-full my-6' : 'col-span-full mb-6' }
                style={{
                    height: '1px'
                }}
            />
        </>
    )
};

export default Step1CartItemDesktop;